<app-merchant-details
  [identity]="identity"
  [merchant]="merchant"
  [merchants]="recentMerchants"
></app-merchant-details>

<form
  name="notesForm"
  [formGroup]="notesForm"
  (submit)="saveNote()"
  *ngIf="
    payrollAccount && hasEntitlement('CARDHOLDERS_NOTES_CREATE') && !dataLoading
  "
>
  <div class="card card-nc">
    <div class="card-heading ">
      <span class="icon-NC_createnotes"></span>
      <span class="cardHeaderHeading"> CREATE NOTES </span>&nbsp;&nbsp;
      <span class="pull-right save-card">
        <button
          type="submit"
          [disabled]="savingNote"
          id="submitButton"
          class="btn btn-nc"
        >
          SAVE <i [ngClass]="{ 'fa fa-spinner fa-spin': savingNote }"> </i>
        </button>
      </span>
    </div>
    <div class="card-body">
      <div class="row">
        <div class="col-md-3">
          <label for="location" class="col-md-12 control-label labelCommon">
            Category
          </label>
          <div class="form-group col-md-12">
            <select
              class="form-control input-sm"
              name="noteCat"
              id="noteCat"
              (change)="change()"
              formControlName="noteCat"
              required
            >
              <option value="" disabled="disabled" selected
                >Please Select...
              </option>
              <option *ngFor="let noteCat of categories" [value]="noteCat.name">
                {{ noteCat.name }}</option
              >
            </select>
            <span
            class="help-block has-error validationMessage"
            *ngIf="
              !notesForm.get('noteCat').valid &&
              notesForm.get('noteCat').touched &&
              notesForm.get('noteCat').errors['required']
            "
          >
            Required
          </span>
          </div>
        </div>
        <div class="form-group col-md-3">
          <label for="location" class="col-md-12 control-label labelCommon">
            Type
          </label>
          <div class="col-md-12">
            <select
              class="form-control input-sm"
              name="noteType"
              id="noteType"
              formControlName="noteType"
              required
            >
              <option value="" disabled="disabled" selected
                >Please Select...
              </option>
              <option *ngFor="let noteType of noteTypes" [value]="noteType">
                {{ noteType }}
              </option>
            </select>
            <span
            class="help-block has-error validationMessage"
            *ngIf="
              !notesForm.get('noteType').valid &&
              notesForm.get('noteType').touched &&
              notesForm.get('noteType').errors['required']
            "
          >
            Required
          </span>
          </div>
        </div>
        <div class="form-group col-md-3">
          <label for="location" class="col-md-12 control-label labelCommon">
            Case ID
          </label>
          <div class="col-md-12">
            <input
              type="text"
              class="form-control input-sm"
              id="noteCase"
              formControlName="noteCase"
              name="noteCase"
              maxlength="13"
            />
          </div>
        </div>
      </div>
      <div class="row">
        <label for="location" class="col-md-11 control-label labelCommon">
          Description
        </label>
        <label for="location" class="col-md-1 control-label labelCommon">
          ({{ inputText.length }}/1000)
        </label>
        <div class="form-group col-md-12" style="padding-bottom:15px;">
          <textarea
            placeholder="Text Here for Notes"
            formControlName="noteDetail"
            style="resize:none"
            name="noteDetail"
            id="noteDetail"
            (keyup)="textInput($event.target.value)"
            class="form-control"
            rows="7"
            maxlength="1000"
            required
          >
          </textarea>
          <span
          class="help-block has-error validationMessage"
          *ngIf="
            !notesForm.get('noteDetail').valid &&
            notesForm.get('noteDetail').touched &&
            notesForm.get('noteDetail').errors['required']
          "
        >
          Required
        </span>
        </div>
      </div>
    </div>
  </div>
</form>
<div *ngIf="dataLoading" class="col-1">
  <i class="fa fa-spinner fa-spin fa-4x"></i>
</div>
<div class="card card-nc" *ngIf="hasEntitlement('CARDHOLDERS_NOTES_LIST')">
  <div class="card-heading ">
    <i class="fa fa-keyboard-o"></i
    ><span class="cardHeaderHeading"> NOTES </span>
  </div>
  <div class="card-body" style="padding: 0px;">
    <div class="row notesRow" *ngFor="let note of notes">
      <div class="col-md-12 text-nowrap" style="padding-top: 5px;">
        <div class="row">
          <div class="col-md-2">
            <div class="col-md-12 labelCommon">Date Time</div>
            <div class="col-md-12 staticText1">
              {{ note.dateCreated | date: 'mediumDate' }}
            </div>
          </div>
          <div class="col-md-2">
            <div class="col-md-12 labelCommon">Name</div>
            <div class="col-md-12 staticText1">{{ note.creater }}</div>
          </div>
          <div class="col-md-2">
            <div class="col-md-12 labelCommon">Case Id</div>
            <div class="col-md-12 staticText1">{{ note.caseId }}</div>
          </div>
          <div class="col-md-2">
            <div class="col-md-12 labelCommon">Category</div>
            <div class="col-md-12 staticText1">{{ note.name }}</div>
          </div>
          <div class="col-md-2">
            <div class="col-md-12 labelCommon">Type</div>
            <div class="col-md-12 staticText1">{{ note.type }}</div>
          </div>
        </div>
        <div
          class="col-md-12 noteDetailText wrapword"
          style="padding-top: 8px;padding-bottom: 8px;"
        >
          {{ note.detail }}
        </div>
      </div>
    </div>
    <div class="row searchResultsRow" *ngIf="notes.length === 0">
      No account notes found.
    </div>
  </div>
</div>
